import { ICalculationItem } from 'components/calculation/CalculationContacts';

export const calcItemsEKB: ICalculationItem[][] = [
  [
    {
      title: 'Лучистая ул.&nbsp;24',
      times: ['<b>08:00 — 20:00</b>, ежедневно'],
    },
  ],
];
